import {HasChecklistBaseMixin} from "../../widget/mixins/HasChecklistBaseMixin.jsx";
import ResourceEditTabBase from "./ResourceEditTabBase.jsx";
import {PERSISTENCE_STATE_KEYS} from "../../../other/constants/PersistenceStateKeys.jsx";
import { DEEP_LINK_URL_KEYS } from "../../../other/constants/OtherKeys.jsx";

export default class ResourceChecklistTab extends HasChecklistBaseMixin(ResourceEditTabBase) {
  static get $name() {
    return "ResourceChecklistTab";
  }

  static get type() {
    return "resourcechecklisttab";
  }

  get stateId() {
    return PERSISTENCE_STATE_KEYS.resourceChecklistGrid;
  }

  get recordType() {
    return "resourceId";
  }

  get entityType() {
    return "resource";
  }

  get deepLinkUrlKey() {
    return DEEP_LINK_URL_KEYS.resource;
  }
}

ResourceChecklistTab.initClass();